import { DateTime } from "luxon";

export const activeRoute = (
  routeName: string,
  pathname: string,
  exact?: boolean
) => {
  if (exact) {
    return pathname === routeName;
  } else {
    return pathname.includes(routeName);
  }
};

export const getRemainingTrialDays = (
  freeTrialExpiresAtTs: number | null | undefined,
  createdAtTs: number
) => {
  if (freeTrialExpiresAtTs) {
    const remainingDays = Math.floor(
      (freeTrialExpiresAtTs - DateTime.now().toMillis()) / (60 * 60 * 24 * 1000)
    );
    if (remainingDays <= 0) return 0;
    return remainingDays;
  }
  const daysSinceCreation = Math.floor(
    (DateTime.now().toMillis() - createdAtTs) / (60 * 60 * 24 * 1000)
  );

  return Math.max(0, 7 - daysSinceCreation);
};
